export const DemoSizingView = () => {
	return (
		<div className="is-page-pad-touch">
			<h2 className="mb-5 text-3xl text-center">Sizing</h2>
		</div>
	)
}
